<app-userapi-shared-oauth [userApi]="userApi" [configured]="userApi.url !== undefined">
  <p translate="INCLUDE_MODALUSERAPI_LABEL_SAGEACTIVE" [translateParams]="{ api: userApi.api.name }"></p>

  <div class="flex space-x-2 mb-12">
    <div class="w-full">
      <app-dropdown
          [hasSelectedItem]="!!userApi.url"
          [items]="[{ value: 'fr' }]"
          [selectedItemDisplayName]="userApi.url"
          (itemSelected)="userApi.url = $event.value; userApi.valid = true"></app-dropdown>
    </div>
  </div>
</app-userapi-shared-oauth>
